import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getRoutesForPoc = async () => {
  try {
    const response = await apiClient.get(`/routes/getAllRoutes/`, { params: { type: 'LEASING' } });
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const createLeasing = async (arr) => {
  try {
    const response = await apiClient.post(`/leasing/createRoute/`, arr);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getAdditionalCostsForPoc = async () => {
  try {
    const response = await apiClient.get(`/routes/getAllAdditionalCost/`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRouteDetailTable = async (startLocation) => {
  try {
    const response = await apiClient.get(`/routes/getRouteDetailTableOnlyStart/${startLocation}`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRouteCostsForPoc = async (id) => {
  try {
    const response = await apiClient.get(`/routes/getRouteCost/${id}`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRouteOneForPoc = async (id) => {
  try {
    const response = await apiClient.get(`routes/getOneRoute/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
export const getRouteOneAdditionlForPoc = async (id) => {
  try {
    const response = await apiClient.get(`/routes/getOneRouteAdditional/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRouteOneAdditionlCount = async (id) => {
  if (!id) {
    return;
  }
  try {
    const response = await apiClient.get(`/routes/countAdditional/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
export const getLinksForSite = async (id) => {
  try {
    const response = await apiClient.get(`/leasing/linksForSite/${id}`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
export const getConnectedSites = async (id) => {
  try {
    const response = await apiClient.get(`/leasing/connectedSites/${id}`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getSitesForLink = async (id) => {
  try {
    const response = await apiClient.get(`/leasing/sitesForLink/${id}`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getNearbySites = async (long, lat) => {
  try {
    const response = await apiClient.get(`/leasing/nearbySites/${long}/${lat}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
export const getNearbySitesForAllNetwork = async (long, lat, network) => {
  try {
    const response = await apiClient.get(
      `/kmz/nearestKMZSite?selectedKmz=&long=${long}&lat=${lat}&network=${network}`
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getOneNearbySites = async (long, lat) => {
  try {
    const response = await apiClient.get(`/leasing/singleNearbySites/${long}/${lat}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
